var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91797 1.49902C1.91797 1.22288 2.14183 0.999023 2.41797 0.999023H14.497C14.7732 0.999023 14.997 1.22288 14.997 1.49902V8.39031C14.997 8.66645 14.7732 8.89031 14.497 8.89031H7.29664V9.89031H8.61691L8.6415 13.0006H6.99414V14.0006H12.0224V13.0006H9.64154L9.61694 9.89031H14.497C15.3255 9.89031 15.997 9.21874 15.997 8.39031V1.49902C15.997 0.670597 15.3255 -0.000976562 14.497 -0.000976562H2.41797C1.58954 -0.000976562 0.917969 0.670595 0.917969 1.49902V3.67448H1.91797V1.49902ZM1 12.8712V5.97991L5.03388 5.97991V12.8712L5.03388 13.8712V12.8712L1 12.8712ZM1 13.8712H5.03388C5.58617 13.8712 6.03388 13.4235 6.03388 12.8712V5.97991C6.03388 5.42762 5.58617 4.97991 5.03388 4.97991H1C0.447717 4.97991 0 5.42762 0 5.97991V12.8712C0 13.4235 0.447715 13.8712 1 13.8712Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesSmall);
export default __webpack_public_path__ + "static/media/devices-small.d5f4f0f72ae77bb212bd9d02ab89cd7e.svg";
export { ForwardRef as ReactComponent };